export default __webpack_public_path__ + "static/media/Kacem.93ae2ed8.png";